// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__018Zl {
  width: 100%;
  gap: 0.75rem;
  padding: 0.75rem 0 0.25rem; }

.styles_header__aay4l {
  width: 100%; }

.styles_heading__9VCY9 {
  margin: 0;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #808080b8; }

.styles_list__HEZZn {
  width: 100%;
  gap: 0.55rem; }

.styles_task__pteZC {
  width: 100%;
  box-sizing: border-box;
  gap: 1rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid #8080802e;
  border-radius: 0.9rem;
  background: #fff; }

.styles_taskCopy__TWMKM {
  min-width: 0;
  flex: 1 1;
  gap: 0.2rem; }

.styles_taskName__LATew {
  margin: 0;
  font-size: 1rem; }

.styles_taskText__u66Yu {
  margin: 0;
  color: #808080b8;
  font-size: 0.84rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.styles_empty__nHjb8 {
  color: #808080b8;
  font-size: 0.88rem;
  font-style: italic;
  line-height: 1.4; }
`, "",{"version":3,"sources":["webpack://./src/modules/roadmaps/components/GatewayTasks/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,WAAW;EACX,YAAY;EACZ,0BAA0B,EAAA;;AAG9B;EACI,WAAW,EAAA;;AAGf;EACI,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBCAc,EAAA;;ADGlB;EACI,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,2BCjBc;EDkBd,qBAAqB;EACrB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,SAAO;EACP,WAAW,EAAA;;AAGf;EACI,SAAS;EACT,eAAe,EAAA;;AAGnB;EACI,SAAS;EACT,gBC/Bc;EDgCd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGpB;EACI,gBC1Cc;ED2Cd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n    width: 100%;\n    gap: 0.75rem;\n    padding: 0.75rem 0 0.25rem;\n}\n\n.header {\n    width: 100%;\n}\n\n.heading {\n    margin: 0;\n    font-size: 0.95rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: $grey72;\n}\n\n.list {\n    width: 100%;\n    gap: 0.55rem;\n}\n\n.task {\n    width: 100%;\n    box-sizing: border-box;\n    gap: 1rem;\n    padding: 0.75rem 0.9rem;\n    border: 1px solid $grey18;\n    border-radius: 0.9rem;\n    background: #fff;\n}\n\n.taskCopy {\n    min-width: 0;\n    flex: 1;\n    gap: 0.2rem;\n}\n\n.taskName {\n    margin: 0;\n    font-size: 1rem;\n}\n\n.taskText {\n    margin: 0;\n    color: $grey72;\n    font-size: 0.84rem;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.empty {\n    color: $grey72;\n    font-size: 0.88rem;\n    font-style: italic;\n    line-height: 1.4;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__018Zl`,
	"header": `styles_header__aay4l`,
	"heading": `styles_heading__9VCY9`,
	"list": `styles_list__HEZZn`,
	"task": `styles_task__pteZC`,
	"taskCopy": `styles_taskCopy__TWMKM`,
	"taskName": `styles_taskName__LATew`,
	"taskText": `styles_taskText__u66Yu`,
	"empty": `styles_empty__nHjb8`
};
export default ___CSS_LOADER_EXPORT___;
